/**
 * @file 话术入口
 * @author zhujialu
 */
define(function (require, exports) {
    'use strict'

    var getLanguage = require('../function/getLanguage')

    if (getLanguage() === 'chinese' && BJY.isLiveSell) {
        return require('./chineseSimplifiedLiveSell')
    }
    else {
        return BJY.getLanguage({
            english: require('./english'),
            chineseLive: require('./chineseSimplifiedLive'),
            chineseClassroom: require('./chineseSimplifiedClassroom'),
            japanese: require('./japanese'),
            vietnamese: require('./vietnamese'),
            indonesian: require('./indonesian'),
            chineseTraditional: require('./chineseTraditional')
        })
    }
})
